import { combineReducers } from 'redux'
import { authReducer } from '../authorization/reducer';
import { cashierReducer } from '../../desktop/cashiersUsers/store/reducer';
import { cashiersShiftReducer } from '../../desktop/cashiersShift/store/reducer';
import { withdrawalsReducer } from '../../desktop/withdrawals/store/reducer';
import { replenishmentReducer } from '../../desktop/replenishment/store/reducer';
import { usersReducer } from '../../desktop/users/store/reducer';
import { historyReducer } from '../../desktop/report-event/store/reducer';
import { balanceReducer } from '../../desktop/report-balance/store/reducer';
import { ggrReducer } from '../../desktop/report-finance/store/reducer';
import { searchUsersReducer } from '../../desktop/search-user/store/reducer';
import { replenishmentReportReducer } from '../../desktop/gamer-report/store/reducer';
import { informationReducer } from '../../desktop/information_panel/store/reducer';
import { referralsReducer } from '../../desktop/referrals/store/reducer';
import { providerReducer } from '../../desktop/report-provider/store/reducer';
import { bonusesReducer } from '../../desktop/bonuses/store/reducer';
import { personalReducer } from '../../desktop/bonus-personal-issue/store/reducer';
import { reportBonusesReducer } from '../../desktop/report-bonuses/store/reducer';
import { kycReducer } from '../../desktop/kyc/store/reducer';
import { jackpotReducer } from '../../desktop/jackpot/store/reducer';
import { jackpotReportReducer } from '../../desktop/report-jackpot/store/reducer';
import { tournamentReducer } from '../../desktop/tournament/store/reducer';
import { dailyReducer } from '../../desktop/report-daily/store/reducer';
import { supportReducer } from '../../desktop/support/store/reducer';
import { withdrawalsAwaitingReducer } from '../../desktop/report-unconfirmed/store/reducer';
import { paymentReducer } from '../../desktop/PaymentSystem/store/reducer';
import { groupsReducer } from '../../desktop/report-group/store/reducer';
import { creditReducer } from '../../desktop/credit/store/reducer';
import { lotteryReducer } from '../../desktop/lottery/store/reducer';
import { adminReducer } from '../../desktop/admin/store/reducer';
import { creditHistoryReducer } from '../../desktop/history-credit/store/reducer';
import { presentReducer } from '../../desktop/presentConfirmation/store/reducer';
import { keyReducer } from '../../desktop/qiwi/store/reducer';
import { freespinReducer } from '../../desktop/freespin/store/reducer';
import { mobileAdminReducer } from '../../mobile/security/store/reducer';
import { mobileTemplateReducer } from '../../mobile/components/templatePage/store/reducer';
import { mobileSupportReducer } from '../../mobile/support/store/reducer';
import { mobileHistoryReducer } from '../../mobile/report/store/reducer';
import { mobileCreditReducer } from '../../mobile/credit/store/reducer';
import { informationMobileReducer } from '../../mobile/InformationPanel/store/reducer';
import { replenishmentMobileReducer } from '../../mobile/replenishment/store/reducer';
import { withdrawalsMobileReducer } from '../../mobile/withdrawals/store/reducer';
import { kycMobileReducer } from '../../mobile/kyc/store/reducer';
import { providerMobileReducer } from '../../mobile/games/store/reducer';
import { paymentMobileReducer } from '../../mobile/payment/store/reducer';
import { cashiersMobileReducer } from '../../mobile/cashiers/store/reducer';
import { jackpotMobileReducer } from '../../mobile/jackpot/store/reducer';
import { usersMobileReducer } from '../../mobile/gamer/store/reducer';
import { objectOrganizationReducer } from '../../desktop/organization/store/reducer';
import { freespinGameReducer } from '../../desktop/freespinGame/store/reducer';
import { messangerReducer } from '../../desktop/messager/store/reducer';
import { exchangeRatesReducer } from '../../desktop/exchangeRates/store/reducer';
import { pinsaleReducer } from '../requestApi/reducer/pinsale/reducer';
import { statisticsReducer } from '../statistics/reducer';
import { codeCountryReducer } from '../../desktop/code-country/store/reducer';
import { currencyReducer } from '../../desktop/currency/store/reducer';
import { dictionaryReducer } from '../../desktop/dictionary/store/reducer';
import { cashbackReducer } from '../../desktop/cashback/store/reducer';
import { gamesReducer } from '../games/reducer';
import { replenishmentGeneralReportReducer } from '../../desktop/general-report/store/reducer';
import { mailingReducer } from '../mailing/reducer';
import { replenishmentTransactionReportReducer } from '../../desktop/transaction/store/reducer';

const rootReducer = (history) => {
  return combineReducers({
    auth: authReducer,
    cashier: cashierReducer,
    cashiersShift: cashiersShiftReducer,
    withdrawals: withdrawalsReducer,
    replenishment: replenishmentReducer,
    users: usersReducer,
    report_event: historyReducer,
    report_balance: balanceReducer,
    ggr: ggrReducer,
    search_user: searchUsersReducer,
    report_replenishment: replenishmentReportReducer,
    information: informationReducer,
    referrals: referralsReducer,
    provider: providerReducer,
    bonuses: bonusesReducer,
    personal: personalReducer,
    report_bonuses: reportBonusesReducer,
    kyc: kycReducer,
    jackpot: jackpotReducer,
    report_jackpot: jackpotReportReducer,
    tournament: tournamentReducer,
    daily: dailyReducer,
    support: supportReducer,
    withdrawalsAwaiting: withdrawalsAwaitingReducer,
    payment: paymentReducer,
    groups: groupsReducer,
    credit: creditReducer,
    lottery: lotteryReducer,
    admin: adminReducer,
    creditHistory: creditHistoryReducer,
    present: presentReducer,
    key: keyReducer,
    freespin: freespinReducer,
    adminMobile: mobileAdminReducer,
    templateMobile: mobileTemplateReducer,
    supportMobile: mobileSupportReducer,
    historyMobile: mobileHistoryReducer,
    creditMobile: mobileCreditReducer,
    informationMobile: informationMobileReducer,
    replenishmentMobile: replenishmentMobileReducer,
    withdrawalsMobile: withdrawalsMobileReducer,
    kycMobile: kycMobileReducer,
    providerMobile: providerMobileReducer,
    paymentMobile: paymentMobileReducer,
    cashiersMobile: cashiersMobileReducer,
    jackpotMobile: jackpotMobileReducer,
    usersMobile: usersMobileReducer,
    objectOrganization: objectOrganizationReducer,
    freespinGame: freespinGameReducer,
    messanger: messangerReducer,
    exchangeRates: exchangeRatesReducer,
    pinsale: pinsaleReducer,
    statistics: statisticsReducer,
    code_country: codeCountryReducer,
    currency: currencyReducer,
    dictionary: dictionaryReducer,
    cashback: cashbackReducer,
    games: gamesReducer,
    replenishmentGeneralReport: replenishmentGeneralReportReducer,
    mailing: mailingReducer,
    replenishmentTransactionReport: replenishmentTransactionReportReducer
  })
}

export {
  rootReducer
}